export { View as WebView } from 'react-native';
